import React from 'react';
import stylesheet from './SectionImage.css';

type Props = {
  section: $TSFixMe;
};

export const SectionImage = ({ section }: Props) => {
  const { options } = section;
  return (
    <div>
      <img
        data-testid={`${options.origin_id}-section-image`}
        className={stylesheet.sectionImage}
        src={
          options.image_url ||
          'https://cdn-images.mailchimp.com/image-placeholder.png'
        }
        alt={
          options.image_url
            ? options.image_alt_text || 'content'
            : 'None uploaded, uploaded image will appear here'
        }
      />
    </div>
  );
};

export default SectionImage;
